import React, { useState} from 'react';

// MUI Components
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Components
import Users from '../partials/settings/users';
import IllegalPlugins from '../partials/settings/illegal-plugins';
// import StagePassword from '../partials/settings/stage-password';
// import Audit from '../partials/settings/audit';
import ScheduledAlerts from '../partials/settings/scheduled-alerts';

const Settings = () => {

    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        { label: 'Users', component: <Users /> },
        { label: 'Illegal Plugins', component: <IllegalPlugins /> },
        // { label: 'Audit', component: <Box>Audit</Box> },
        { label: 'Scheduled Alerts', component: <ScheduledAlerts /> },
    ]

    return (
        <Container maxWidth="lg">
            <Box className='settings-container'>
                <Tabs
                    className='settings-tabs'
                    orientation="vertical"
                    value={activeTab}
                    onChange={(event, newValue) => setActiveTab(newValue)}
                    aria-label="Vertical tabs example"
                >
                    {tabs.map((tab, index) => (
                        <Tab key={index} label={tab.label} />
                    ))}
                </Tabs>
                <Box className='settings-panel'>
                    {tabs[activeTab].component}
                </Box>
            </Box>
        </Container>
    );
    
};

export default Settings;